<script setup lang="ts">

</script>

<template>
    <div class="columns mt-5">
        <div class="column has-text-centered">
            <router-link :to="{ name: 'RecentStats' }">
                <b-icon
                    icon="chart-areaspline-variant"
                    size="is-large" />
                <h2 class="title is-4 mt-4">
                    Recent API usage
                </h2>
                <p class="subtitle is-6 mt-2">
                    API requests across clients and resources, last 24 hours.
                </p>
            </router-link>
        </div>
        <div class="column has-text-centered">
            <router-link :to="{ name: 'ClientApplications' }">
                <b-icon
                    icon="account-group"
                    size="is-large" />
                <h2 class="title is-4 mt-4">
                    Client applications
                </h2>
                <p class="subtitle is-6 mt-2">
                    All registered client applications and their activity.
                </p>
            </router-link>
        </div>
        <div class="column has-text-centered">
            <router-link :to="{ name: 'KPIReport' }">
                <b-icon
                    icon="trophy"
                    size="is-large" />
                <h2 class="title is-4 mt-4">
                    Key performance indicators
                </h2>
                <p class="subtitle is-6 mt-2">
                    Performance metrics for the Common Library API.
                </p>
            </router-link>
        </div>
    </div>
    <div class="columns mt-5">
        <div class="column has-text-centered">
            <router-link :to="{ name: 'TreeMap' }">
                <b-icon
                    icon="chart-tree"
                    size="is-large" />
                <h2 class="title is-4 mt-4">
                    Library volume distribution
                </h2>
                <p class="subtitle is-6 mt-2">
                    Visual tree map of libraries and library sets.
                </p>
            </router-link>
        </div>
        <div class="column has-text-centered">
            <router-link :to="{ name: 'UsageEventSearch' }">
                <b-icon
                    icon="magnify"
                    size="is-large" />
                <h2 class="title is-4 mt-4">
                    Usage event search
                </h2>
                <p class="subtitle is-6 mt-2">
                    Search and inspect recent API usage events.
                </p>
            </router-link>
        </div>
        <div class="column has-text-centered">
            &nbsp;
        </div>
    </div>
</template>
